import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_SOCKET_SERVER}`,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    }
});

axiosInstance.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.code === "ECONNABORTED") {
            console.error("Request timed out:", err.config?.url);
        }
        return Promise.reject(err);
    }
);

export default axiosInstance;
